import { render, staticRenderFns } from "./EmailsListDetail.vue?vue&type=template&id=cca7d51c&"
import script from "./EmailsListDetail.vue?vue&type=script&lang=js&"
export * from "./EmailsListDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cca7d51c')) {
      api.createRecord('cca7d51c', component.options)
    } else {
      api.reload('cca7d51c', component.options)
    }
    module.hot.accept("./EmailsListDetail.vue?vue&type=template&id=cca7d51c&", function () {
      api.rerender('cca7d51c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/emails/components/emails/EmailsListDetail.vue"
export default component.exports